import React from 'react'
import './NotFoundPage.css'

export default () => (
  <div className='NotFoundPage'>
    <h3>Sorry, page not found!</h3>
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js